import React from 'react'
import Link from 'gatsby-link'

const Header = ({ siteTitle }) => (
  <div
    style={{
      background:
        'linear-gradient(45deg, rgb(92, 153, 214), rgb(41, 102, 163))',
      marginBottom: '3rem',
      borderBottom: '.15rem solid hsla(210, 30%, 95%, 1)',
    }}
  >
    <div
      style={{
        margin: '0 auto',
        maxWidth: 960,
        padding: '.65rem 1.0875rem .5rem 1.0875rem',
        display: 'flex',
        justifyContent: 'space-between',
        alignItems: 'center'
      }}
    >
      <Link
        to="/"
        style={{
          color: '#fff',
          textDecoration: 'none',
          fontSize: '1.5rem',
          textTransform: 'uppercase',
          fontWeight: '800',
        }}
      >
        ⚡<span>Zap</span>
        <span style={{ fontWeight: 'normal' }}>Gigs</span>
      </Link>
      {/* <Link
        to="/post-a-job"
        style={{
          color: '#fff',
          textDecoration: 'none',
          display: 'inline-block',
          padding: '.25em 1em',
          border: '2px solid white',
          borderRadius: '.25em',
        }}
      >
        Post a job
      </Link> */}
    </div>
  </div>
)

export default Header



// WEBPACK FOOTER //
// ./src/components/header.js